/*LVSTORE*/
const LVStore = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/LVStore.vue');

const LVLite = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/lv/LVLite.vue');
const Autostore = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/lv/Autostore.vue');
const General = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/lv/General.vue');
const Terms = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/lv/Terms.vue');
const Referrals = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/lv/Referrals.vue');
const Social = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/lv/Social.vue');

export default [
  {
    path: 'settings',
    name: 'loyaltyvenue.store.settings',
    redirect: {name: 'loyaltyvenue.store.lvstore'},
    component: {
      template: '<router-view :store=store :store_id=store_id @updated="$emit(\'updated\')" />',
      props: {store: {required:true}, store_id: {required:true}},
    },
    meta: {
      trans: 'loyaltyvenue:general.titles.system_settings',
      icon: 'cog',
    },
    children: [
      {
        path: 'lvlite',
        name: 'loyaltyvenue.store.lvlite',
        component: LVLite,
        meta: {
          icon: 'magic-wand',
          trans: 'loyaltyvenue:general.titles.lvlite',
          menu: true,
        },
      },
      {
        path: 'lvstore',
        name: 'loyaltyvenue.store.lvstore',
        component: LVStore,
        redirect: {name: 'loyaltyvenue.store.lvstore.lvstore'},
        meta: {
          icon: 'store',
          trans: 'loyaltyvenue:stores.tabs.lvstore',
          menu: true,
        },
        children: [
          {
            path: 'autostore',
            name: 'loyaltyvenue.store.lvstore.lvstore',
            component: Autostore,
          },
          {
            path: 'general',
            name: 'loyaltyvenue.store.lvstore.general',
            component: General,
          },
          {
            path: 'tos',
            name: 'loyaltyvenue.store.lvstore.tos',
            component: Terms,
          },
          {
            path: 'referral',
            name: 'loyaltyvenue.store.lvstore.referral',
            component: Referrals,
          },
          {
            path: 'social',
            name: 'loyaltyvenue.store.lvstore.social',
            component: Social,
          },
        ],
      },
    ],
  },
]


// WEBPACK FOOTER //
// ./src/apps/loyaltyvenue/routes_settings.js